module.exports = __webpack_public_path__ + "static/ted-bg-90715c53d72d09efc6cf880fccde3936.png";